import React from 'react';

import { FormattedMessage } from 'react-intl';
import { PendingAuthenticationScreen } from '../PendingAuthenticationScreen/PendingAuthenticationScreen';
import { messages as bankidMessages } from '../AwaitingMobileBankIdAuthenticationLocalPrompt/messages';
import { CredentialsEntity } from '../../../../../../../models/credentials';
import { ThirdPartyRedirectButton as ThirdPartyRedirectButtonImport } from '../../../AwaitingThirdpartyAuthenticationContainer/molecules/ThirdPartyRedirectButton/ThirdPartyRedirectButton';
import { PageView } from '../../../../../../../models/analytics';
import { PrimaryButton as PrimaryButtonImport } from '../../../../../../atoms/Button/Button';
import { messages } from './messages';

export type AwaitingTppPendingScreenProps = {
  providerName: string;
  onBack?: () => void;
  credentials: CredentialsEntity;
  ThirdPartyRedirectButton?: typeof ThirdPartyRedirectButtonImport;
};

export const AwaitingTppPendingScreen: React.FC<AwaitingTppPendingScreenProps> = ({
  providerName,
  onBack,
  credentials,
  ThirdPartyRedirectButton = ThirdPartyRedirectButtonImport,
}) => {
  return (
    <PendingAuthenticationScreen
      title={<FormattedMessage {...bankidMessages.authorizeHeader} />}
      primaryText={<FormattedMessage {...messages.instructionsPayAuth} values={{ providerName }} />}
      secondaryText={<FormattedMessage {...messages.providerInfo} values={{ providerName }} />}
      primaryButton={
        <ThirdPartyRedirectButton
          pageView={PageView.AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN}
          credentials={credentials}
          showSubmitButtonInitially
        >
          <FormattedMessage {...bankidMessages.retry} />
        </ThirdPartyRedirectButton>
      }
      onBack={onBack}
    />
  );
};

/* This is just a duplicate of the above to fix a bug in ThirdPartyRedirectButton */
export type AwaitingTppPendingScreenNoAutoRedirectProps = {
  providerName: string;
  onBack?: () => void;
  onClick: () => void;
  credentials: CredentialsEntity;
  PrimaryButton?: typeof PrimaryButtonImport;
};

export const AwaitingTppPendingNoAutoRedirectScreen: React.FC<
  AwaitingTppPendingScreenNoAutoRedirectProps
> = ({ providerName, onBack, onClick, PrimaryButton = PrimaryButtonImport }) => {
  return (
    <PendingAuthenticationScreen
      title={<FormattedMessage {...bankidMessages.authorizeHeader} />}
      primaryText={<FormattedMessage {...messages.instructionsPayAuth} values={{ providerName }} />}
      secondaryText={<FormattedMessage {...messages.providerInfo} values={{ providerName }} />}
      primaryButton={
        <PrimaryButton
          pageView={PageView.AWAITING_THIRD_PARTY_AUTHENTICATION_SCREEN}
          onClick={onClick}
        >
          <FormattedMessage {...bankidMessages.retry} />
        </PrimaryButton>
      }
      onBack={onBack}
    />
  );
};
